var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"webrtc-streamer-container"},[_c('video',{ref:"vjsVideo",staticClass:"video-js",attrs:{"id":"vjsVideo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }